import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../components/Loading";
import DropdownMenu from './components/Dropdown'
import _, { set, times, wrap } from 'lodash';
import RemoveSvg from '../../svgs/RemoveSvg'
import FileDropzone from '../../components/FileDropzone'
import { uploadPhoto } from "../../services/documents";
import ContentEditor from './components/ContentEditor'
import { fetchPromotions } from "../../services/promotions";
import { deleteProduct, fetchProductById, updateProduct } from "../../services/products";
import { fetchPartnerById } from "../../services/partners";
import TshopProductPreview from './components/TshopProductPreview'

const TABS = ['商品管理','關於商品','商品預覽'];

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState({})
    useEffect(() => {
        fetchData()
    }, [props.token])

    const [partnerData, setPartnerData] = useState({})
    const fetchPartnerData = async () => {
        let res = await fetchPartnerById(data.partnerId)
        if (res.result) {
            setPartnerData(res.result)
        }
    }
    useEffect(() => {
        if (data.partnerId) {
            fetchPartnerData()
        }
    }, [data.partnerId])

    async function fetchData() {
        let res = await fetchProductById(id)
        if (res.result) {
            setData(res.result)
        }
    }
    const refresh = async () => {
        fetchData()
    }
    const onDropImageFile = (field) => async (files) => {
        if (files.length > 1) {
            alert(`Only one file is allowed.`)
            return
        }
        const file = files[0]
        if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 5) {
            alert(`File size must be within 5 MB`)
            return
        }

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, id, `${field}_${Math.floor(Math.random() * 1000)}`)
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                await updateProduct(props.token?.token, id, { [field]: filepath });
                setData({ ...data, [field]: filepath })
            }
        }
        setIsloading(false);
    }

    const save = async () => {
        if (!data.name || data.name.length < 3) {
            alert('合作夥伴名稱長度需大於3')
            return
        }
        setIsloading(true)
        let res = await updateProduct(props.token?.token, id, {
            name: data.name,
            subtitle: data.subtitle,
            description: data.description,
            status: data.status,
            order: data.order,
            content: data.content||[],
            isTshopRecommended:!!data.isTshopRecommended,
            isTshopWeeklyPopular:!!data.isTshopWeeklyPopular,
            isTshopTopViews:!!data.isTshopTopViews,
            isTshopMostFavourited:!!data.isTshopMostFavourited,
            price: data.price||0,
            price2: data.price2||0,
            price3: data.price3||0,
            thumbnail: data.thumbnail||null,
            hero: data.hero||null,
            discountMessage: data.discountMessage||'null',
            tags: data.tags||[],
            isRefundable: !!data.isRefundable,
            isDisplayOnly: !!data.isDisplayOnly,
            isNormalUserDisabled: !!data.isNormalUserDisabled,
            isStarUserDisabled: !!data.isStarUserDisabled,
            isPremiumUserDisabled: !!data.isPremiumUserDisabled,
            isHideDirectPayment: !!data.isHideDirectPayment,
        });
        if (res.errno) {
            alert(res.message || '更新失敗')
        } else {
            alert('更新成功')
            refresh()
        }
        setIsloading(false);
    }




    const [tab, setTab] = useState(TABS[0])


    const [promotionList, setPromotionList] = useState([])
    async function fetchPromotionList() {
        let res = await fetchPromotions({  }, { limit: 999 }, { name: 1 })
        if (res.errno) return
        if (res.result)
            setPromotionList(res.result)
    }
    useEffect(() => {
        fetchPromotionList()
    }, [])



    {/*introduction handler*/ }
    const handleContentOrder = (field) => (oldLayout, newLayout) => {
        let array = []
        newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
        for (let i of newLayout) {
            let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
            array.push(data[field][oldIndex]);
        }
        let d = { ...data };
        d[field] = array;
        setData(d);
    }
    const handleAddContent = (field) => () => {
        let d = { ...data };
        let c = [...(d[field] || [])]
        c.push({ id: Date.now(), type: 'text', content: '', isTitle: false })
        d[field] = c
        setData(d);
    }
    const handleSectionDeleteContent = (field) => (card, cardIndex) => {
        let d = { ...data }
        let c = d?.[field] || [];
        c.splice(cardIndex, 1);
        d[field] = c;
        setData(d)
    }
    const handleSectionEditContent = (field) => (card, cardIndex, key, value) => {
        let d = { ...data };
        d[field][cardIndex][key] = value
        setData(d);
    }
    {/*introduction handler*/ }

    const [isDeleting, setIsDeleting] = useState(false)
    const handleDelete = async () => {
        setIsloading(true)
        let res = await deleteProduct(props.token?.token, id)
        if (res.errno) {
            alert(res.message || '刪除失敗')
            setIsloading(false)
        } else {
            alert('刪除成功')
            navigate('/cms/partners/' + data.partnerId) // Navigate back to the partner details page 
        }
    }


    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] p-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>
            <div className="w-full flex flex-row gap-[16px]">
                <div onClick={navigateTo(`/cms/partners/${data.partnerId}`)} className="cursor-pointer hover:opacity-[.5] text-white font-[700] text-[22px] px-[12px] py-[4px] rounded-[8px]" style={{background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)'}}>
                    返回
                </div>
                <div  onClick={()=>{setIsDeleting(true)}} className="cursor-pointer hover:opacity-[.5] text-white font-[700] text-[22px] px-[12px] py-[4px] rounded-[8px]" style={{background: 'linear-gradient(180deg, #8C706B 0%, rgba(140, 112, 107, 0.2) 100%)'}}>
                    刪除
                </div>
            </div>
            <div className='font-[700] p-[16px] bg-[white] rounded-[7px] w-full'>{data.name}</div>
            <div className="w-full flex flex-row gap-[16px] flex-wrap">
                {TABS.map((item, index) =>
                    <div key={item} className="flex flex-row items-center justify-center cursor-pointer" style={{ fontWeight: item === tab ? '700' : '400', fontSize: '16px', color: item === tab ? '#000' : '#00000099', padding: '8px 16px', borderBottom: item === tab ? '2px solid #000' : 'none' }} onClick={() => { setTab(item) }}>
                        {item}
                    </div>
                )}
            </div>

            {tab === '商品管理' && <div className="w-full flex flex-col gap-[16px]">
                <div className="w-full gap-[16px] flex flex-row items-start justify-start flex-wrap">
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>商品名稱</div>
                        <input value={data?.name || ''} onChange={(e) => { setData({ ...data, name: e.target.value }) }} placeholder='商品名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>副標題</div>
                        <input value={data?.subtitle || ''} onChange={(e) => { setData({ ...data, subtitle: e.target.value }) }} placeholder='副標題' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-[2] flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>描述</div>
                        <input value={data?.description || ''} onChange={(e) => { setData({ ...data, description: e.target.value }) }} placeholder='描述' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>是否禁止普通用戶購買</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isNormalUserDisabled ? '是' : '否'}
                            select={(o, oi) => { setData({ ...data, isNormalUserDisabled: o === '是' }) }}
                        />
                    </div>
                    {data?.isNormalUserDisabled||<div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> T.Dollar 價格 (普通用戶)</div>
                        <input value={data?.price ?? ''} type="number" onChange={(e) => {
                            let num = parseInt(e.target.value) ?? 0
                            setData({ ...data, price: num < 0 ? 0 : num })
                        }} placeholder='價格' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>}
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>是否禁止星級會員購買</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isStarUserDisabled ? '是' : '否'}
                            select={(o, oi) => { setData({ ...data, isStarUserDisabled: o === '是' }) }}
                        />
                    </div>
                    {data?.isStarUserDisabled||<div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> T.Dollar 價格 (星級會員)</div>
                        <input value={data?.price2 ?? ''} type="number" onChange={(e) => {
                            let num = parseInt(e.target.value) ?? 0
                            setData({ ...data, price2: num < 0 ? 0 : num })
                        }} placeholder='價格' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>}
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>是否禁止尊享會員購買</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isPremiumUserDisabled ? '是' : '否'}
                            select={(o, oi) => { setData({ ...data, isPremiumUserDisabled: o === '是' }) }}
                        />
                    </div>
                    {data?.isPremiumUserDisabled||<div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> T.Dollar 價格 (尊享會員)</div>
                        <input value={data?.price3 ?? ''} type="number" onChange={(e) => {
                            let num = parseInt(e.target.value) ?? 0
                            setData({ ...data, price3: num < 0 ? 0 : num })
                        }} placeholder='價格' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>}
                    <div className='flex-[2] flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>折扣資訊</div>
                        <input value={data?.discountMessage || ''} onChange={(e) => { setData({ ...data, discountMessage: e.target.value }) }} placeholder='折扣資訊' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>商品狀態</div>
                        <DropdownMenu options={['已公開', '草稿']}
                            value={data?.status === 'published' ? '已公開' : '草稿'}
                            select={(item, index) => {
                                setData({ ...data, status: item === '已公開' ? 'published' : 'draft' })
                            }}
                        />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> 顯示順序（數值越大，顯示越前）</div>
                        <input value={data?.order ?? ''} type="number" onChange={(e) => {
                            let num = parseInt(e.target.value) ?? 99
                            setData({ ...data, order: num < 0 ? 0 : num })
                        }} placeholder='顯示順序' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                     {[
                        { label: '為您推薦', field: 'isTshopRecommended' },
                        { label: '每週熱門', field: 'isTshopWeeklyPopular' },
                        { label: '最高瀏覽', field: 'isTshopTopViews' },
                        { label: '最多收藏', field: 'isTshopMostFavourited' },
                    ]?.map((item, index) => <div key={index} className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>{item?.label}</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.[item.field] ? '是' : '否'}
                            select={(o, oi) => { setData({ ...data, [item.field]: o === '是' }) }}
                        />

                    </div>)}
                   <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> 是否可退款</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isRefundable ? '是' : '否'}
                            select={(o, oi) => { setData({ ...data, isRefundable: o === '是' }) }}
                        />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>僅顯示（無法購買)</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isDisplayOnly ? '是' : '否'}
                            select={(o, oi) => { setData({ ...data, isDisplayOnly: o === '是' }) }}
                        />
                    </div>
                    <div className="flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]">
                        <div className='font-[700]'> 隱藏直接付款選項</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isHideDirectPayment ? '是' : '否'}
                            select={(o, oi) => { setData({ ...data, isHideDirectPayment: o === '是' }) }}
                        />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[600px] min-w-[600px] justify-start mt-[8px]'>
                        <div className='font-[700]'> 產品類別 </div>
                        <div className="flex flex-row items-center justify-start gap-[8px]">
                        {partnerData?.tags?.map((item, index) =>
                            <div key={index} onClick={()=>{
                                let d = { ...data }
                                if (d.tags?.includes(item)) {
                                    d.tags = d.tags.filter((i) => i !== item)
                                } else {
                                    d.tags = [...(d.tags || []), item]
                                }
                                setData(d)
                            }} className='cursor-pointer flex flex-row items-center justify-start gap-[8px] border-[1px] border-[#00000099] rounded-[4px] px-[8px] py-[4px] bg-[white]' style={{ opacity: data.tags?.includes(item) ? 1 : 0.5 }}>
                                {item}
                            </div>
                        )}
                        </div>
                    </div>
                </div>
                <div className='w-full flex flex-col max-w-[600px] min-w-[400px] gap-[8px] mt-[8px]'>
                    <div className='font-[700]'>封面圖片</div>
                    <div className="w-full flex flex-row gap-[8px]">
                        {data?.thumbnail && <div className='relative w-full'>
                            {
                                data?.thumbnail
                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={data?.thumbnail} alt='image' />
                                    : <div>
                                    </div>
                            }
                            <div onClick={() => { setData({ ...data, thumbnail: '' }) }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                <RemoveSvg />
                            </div>
                        </div>}
                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                            <FileDropzone onDropFile={onDropImageFile('thumbnail')} data={data} />
                        </div>
                    </div>
                </div>

                <div className='w-full flex flex-col max-w-[600px] min-w-[400px] gap-[8px] mt-[8px]'>
                    <div className='font-[700]'>產品主圖</div>
                    <div className="w-full flex flex-row gap-[8px]">
                        {data?.hero && <div className='relative w-full'>
                            {
                                data?.hero
                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={data?.hero} alt='image' />
                                    : <div>
                                    </div>
                            }
                            <div onClick={() => { setData({ ...data, hero: '' }) }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                <RemoveSvg />
                            </div>
                        </div>}
                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                            <FileDropzone onDropFile={onDropImageFile('hero')} data={data} />
                        </div>
                    </div>
                </div>
                <div className="flex flex-row items-center justify-start w-full gap-[16px] mt-[24px]">
                    <div onClick={save} className="cursor-pointer text-[#6E604C] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#6E604C20] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #6E604C' }}>
                        儲存
                    </div>
                    <div onClick={refresh} className="cursor-pointer text-[#000] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#ccc] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #000' }}>
                        重新整理
                    </div>
                </div>
            </div>}


            {tab === '關於商品' &&
                <div className="w-full flex flex-col gap-[16px]">
                    <ContentEditor
                        data={data}
                        field={'content'}
                        textField={'content'}
                        refresh={refresh}
                        onDelete={handleSectionDeleteContent('content')}
                        onAddCard={handleAddContent('content')}
                        onEditKey={handleSectionEditContent('content')}
                        updateOrder={handleContentOrder('content')}
                        allowImageRedirect={true}
                        save={updateProduct}
                    />
                </div>}

            {tab === '商品預覽' && <TshopProductPreview data={data} partnerData={partnerData} />}

            {isDeleting && <div className='fixed top-0 left-0 w-full h-full bg-[#00000099] flex items-center justify-center z-[100]'>
                <div className='bg-white p-[24px] rounded-[8px] flex flex-col items-center justify-start gap-[16px]'>
                    <div className='text-[20px] font-[700]'>確定要刪除此商品嗎？</div>
                    <div className='text-[16px] font-[400]'>刪除後將無法恢復，請謹慎操作。</div>
                    <div className='flex flex-row items-center justify-start gap-[16px]'>
                        <div onClick={() => { setIsDeleting(false) }} className='cursor-pointer text-[#000] font-[700] text-[16px] px-[16px] py-[8px] rounded-[4px]' style={{ backgroundColor: '#ccc' }}>
                            取消
                        </div>
                        <div onClick={handleDelete} className='cursor-pointer text-[#fff] font-[700] text-[16px] px-[16px] py-[8px] rounded-[4px]' style={{ backgroundColor: '#ff0000' }}>
                            刪除
                        </div>
                    </div>
                </div>
            </div>}
            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
